// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__olRa6","colCheckbox":"styles_colCheckbox__2McDK"};